export interface countryParameter {
    countryCode: string;
    companyCode: string;
    parameterGroup: string;
    parameterCode: string;
    parameterId: string;
    value1: string;
}

export interface countryList {
    countryCode: string;
    countryDesc: string;
}

export interface customerParameter {
    customerCode: string;
    parameterGroup: string;
    parameterCode: string;
    parameterId: string;
    value1: string;
}

export interface paymentMethod {
    parameterGroup: string;
    parameterCode: string;
}
